var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongCaogao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tongyong_caogao_svg__clip0_5124_53474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 6h6M5 8.5h3",
    stroke: "#3F465C",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37 12.03a.2.2 0 01.058-.137l4.54-4.54a.5.5 0 01.707.708l-4.54 4.54a.2.2 0 01-.136.058l-.54.013a.1.1 0 01-.103-.102l.014-.54z",
    fill: "#3F465C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1a1 1 0 00-1 1v12a1 1 0 001 1h10a1 1 0 001-1v-3a.5.5 0 00-1 0v3H3V2h10v4a.5.5 0 001 0V2a1 1 0 00-1-1H3z",
    fill: "#3F465C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tongyong_caogao_svg__clip0_5124_53474"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/tongyong_caogao.270f127e.svg";
export { SvgTongyongCaogao as ReactComponent };